(ns shared.core.keybind.data
  (:require [shared.core.reactive :as re]
            [shared.core.components.modals.data :as modals.d]
            [keybind.core :as key]))

(def keybind-path [:keybind])
(def modal-keys-with-bindings-path (conj keybind-path :modal-keys-with-bindings))

(defn all-routes-bindings [db]
  (get-in db (conj keybind-path :all-routes)))

(defn current-route-bindings [db]
  (get-in db (conj keybind-path :current-route)))

(re/reg-sub :keybind/current-route-bindings- current-route-bindings)

(re/reg-sub
  :keybind/current-route-bindings-paused?-
  (fn [db]
    (get-in db (conj keybind-path :current-route-bindings-paused?))))

(defn add-key-bindings [bindings]
  (doall
    (for [[spec k cb] bindings]
      (key/bind! spec k (fn [e]
                          (cb e)
                          (.preventDefault e)
                          (.stopPropagation e))))))

(defn remove-key-bindings [bindings]
  (doall
    (for [[spec k _] bindings]
      (key/unbind! spec k))))

(re/reg-event-db
  :keybind/add-current-route-bindings re/middleware
  (fn [db [bindings]]
    (let [bindings (if (-> bindings (first) (vector?)) bindings [bindings])]
      (remove-key-bindings (current-route-bindings db))
      (add-key-bindings bindings)
      (assoc-in db (conj keybind-path :current-route) bindings))))

(re/reg-event-db
  :keybind/add-current-route-binding re/middleware
  (fn [db [binding]]
    (add-key-bindings [binding])
    (update-in db (conj keybind-path :current-route) conj binding)))

(re/reg-event-db
  :keybind/remove-current-route-bindings re/middleware
  (fn [db]
    (remove-key-bindings (current-route-bindings db))
    (update-in db keybind-path dissoc :current-route)))

(re/reg-event-db
  :keybind/remove-current-route-binding re/middleware
  (fn [db [k]]
    (when-let [binding (some->> (current-route-bindings db)
                                (filter #(= (second %) k))
                                (first))]
      (remove-key-bindings [binding]))
    (assoc-in db (conj keybind-path :current-route) (filter #(not= (second %) k) (current-route-bindings db)))))

(re/reg-event-db
  :keybind/add-all-routes-bindings re/middleware
  (fn [db [bindings]]
    (let [bindings (if (-> bindings (first) (vector?))
                     bindings
                     [bindings])]
      (add-key-bindings bindings)
      (assoc-in db (conj keybind-path :all-routes) bindings))))

(re/reg-event-db
  :keybind/remove-all-routes-bindings re/middleware
  (fn [db]
    (remove-key-bindings (all-routes-bindings db))
    (update-in db keybind-path dissoc :all-routes)))

(re/reg-event-db
  :keybind/remove-all-routes-binding re/middleware
  (fn [db [k]]
    (when-let [binding (some->> (all-routes-bindings db)
                                (filter #(= (second %) k))
                                (first))]
      (remove-key-bindings [binding]))
    (assoc-in db (conj keybind-path :all-routes) (filter #(not= (second %) k) (all-routes-bindings db)))))

(re/reg-event-db
  :keybind/pause-current-route-bindings re/middleware
  (fn [db]
    (remove-key-bindings (all-routes-bindings db))
    (remove-key-bindings (current-route-bindings db))
    (assoc-in db (conj keybind-path :current-route-bindings-paused?) true)))

(defn modal-keys-with-bindings [db]
  (get-in db modal-keys-with-bindings-path #{}))

(re/reg-event-db
  :keybind/register-modal-key-with-bindings re/middleware
  (fn [db [modal-k]]
    (assoc-in db modal-keys-with-bindings-path (conj (modal-keys-with-bindings db) modal-k))))

(re/reg-event-db
  :keybind/resume-current-route-bindings re/middleware
  (fn [db]
    (let [m (modals.d/active-modal db)]
      (when (or (not m) (contains? (modal-keys-with-bindings db) (first m)))
        (add-key-bindings (all-routes-bindings db))
        (add-key-bindings (current-route-bindings db)))
      (assoc-in db (conj keybind-path :current-route-bindings-paused?) false))))
